import { path } from './helpers'
import Vue from 'vue'

let api = () => Vue.prototype.$api

function accountPath (resource) {
  return path(`/webapp/account/${resource}`)
}

export default {
	getSession () {
		return api().get(accountPath('sessions'))
	},
  login (username, password, mfaCode = null) {
    return api().post(accountPath('sessions'), {
      username,
      password,
      twoFactorCode: mfaCode
    })
  },
  sendPasswordUpdateEmail (email) {
    return api().get(accountPath('passwords'), {
			params: {
        email
      }
		})
  },
  setEmail (email, updatePwdToken) {
    return api().put(accountPath('setemail'), {
        email
    },
		{
			headers: {
				'Authorization': `Bearer ${updatePwdToken}`
			}
		})
  },
  updatePassword (password, updatePwdToken) {
    return api().put(accountPath('passwords'), {
      password
    },
    {
			headers: {
				'Authorization': `Bearer ${updatePwdToken}`
			}
		})
  },
  confirmEmail (code, updatePwdToken) {
    return api().post(accountPath('confirm'), {
      code
    },
    {
			headers: {
				'Authorization': `Bearer ${updatePwdToken}`
			}
		})
  },
	reenableAccount (token) {
		return api().get(accountPath('reenable'), { params: {
				token
			}
		})
	},
	loginAssociatedPatient(patientId) {
		return api().post(accountPath(`sessions/${patientId}`))
	},
  isntMultiUser() {
		return api().get('account/isntMultiUser')
	}
}


// WEBPACK FOOTER //
// ./src/repositories/AccountRepository.js